(ns ycweb.app.website.dlp.widgets.horizontalspacer
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]))

(rum/defc horizontal-spacer < rum/reactive [{:keys [properties]}]
  (let [{:horizontal-spacer/keys [spacer-size has-line?]} properties]
    [:div
     {:class
      (u/bem :dlp-spacer
        [(cond
           (and spacer-size has-line?)
           (str spacer-size "-underline")

           (and spacer-size (not has-line?))
           spacer-size

           :else
           :standard)])}]))
